import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { timeline } from '../data/mock';
import SectionTitle from './SectionTitle';
import { Gear } from './animations/Gear';
import { Shield, Award, Globe2 } from 'lucide-react';

export default function About() {
  return (
    <section id="about" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-40" />
      <div className="absolute -right-24 top-1/4 text-cyan-400/[0.05]">
        <div className="spin-rev"><Gear size={420} teeth={20} /></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <SectionTitle
          code="SECTION / 06"
          title="PROGRAM HAKKINDA"
          subtitle="Yerli ve milli denizaltı programının simgesi."
        />

        <div className="mt-16 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <p className="text-slate-300 text-base md:text-lg leading-relaxed">
              <span className="text-cyan-300 font-semibold">UTKU sınıfı denizaltı</span>, Türk savunma sanayinin
              denizaltı mühendisliğindeki en iddialı adımıdır. AIP tahrik, yerli
              CMS ve düşük akustik imza ile sessiz caydırıcılık konseptini ileri
              taşır.
            </p>
            <p className="text-slate-400 text-sm mt-5 leading-relaxed">
              Tasarımdan üretime, sistem entegrasyonundan testlere kadar her
              süreç tümüyle yurt içinde yürütülmektedir. Tüm sınıf üç birim
              olarak planlanmış olup, ilk teslimat 2026 takvimine almıştır.
            </p>

            <div className="mt-8 grid grid-cols-3 gap-px bg-cyan-500/15 border border-cyan-500/15">
              {[
                { icon: Shield, label: '%100 YERLİ', sub: 'Tasarım & Entegrasyon' },
                { icon: Award, label: 'ÖDÜL', sub: 'IDEF 2024 Platın' },
                { icon: Globe2, label: 'İHRACAT', sub: '6 Ülke Görüşmesi' },
              ].map((b, i) => {
                const Icon = b.icon;
                return (
                  <div key={i} className="bg-[#070b12] p-5 text-center">
                    <Icon className="w-5 h-5 text-cyan-400 mx-auto" />
                    <div className="font-display text-base font-bold text-white mt-2">{b.label}</div>
                    <div className="text-[9px] font-mono tracking-[0.2em] text-cyan-400/60 mt-1">{b.sub}</div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Timeline */}
          <div className="lg:col-span-7">
            <div className="relative pl-8 md:pl-12">
              <div className="absolute left-2 md:left-4 top-2 bottom-2 w-px bg-gradient-to-b from-cyan-400 via-cyan-400/40 to-cyan-400/0" />
              {timeline.map((t, i) => (
                <TimelineItem key={t.year} t={t} i={i} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function TimelineItem({ t, i }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-50px' });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, x: -20 }}
      animate={inView ? { opacity: 1, x: 0 } : {}}
      transition={{ duration: 0.6, delay: i * 0.1 }}
      className="relative pb-10 last:pb-0"
    >
      <div className="absolute -left-8 md:-left-12 top-1">
        <div className="relative w-4 h-4 border border-cyan-400 bg-[#05080d] flex items-center justify-center">
          <div className="w-1.5 h-1.5 bg-cyan-400" />
        </div>
      </div>
      <div className="flex items-baseline gap-4 flex-wrap">
        <span className="font-display text-3xl md:text-4xl font-bold text-cyan-300">{t.year}</span>
        <span className="font-mono text-[10px] tracking-[0.25em] text-cyan-400/50">// PHASE 0{i + 1}</span>
      </div>
      <h3 className="font-display text-xl font-bold text-white mt-1">{t.title}</h3>
      <p className="text-slate-400 text-sm mt-2 leading-relaxed max-w-xl">{t.desc}</p>
    </motion.div>
  );
}
